// Remembers which release's notes this browser has already been shown, so the
// "What's new" notice appears once per release and then gets out of the way.

const KEY = 'sleekHearLastSeenVersion';

export function lastSeenVersion(storage = window.localStorage) {
  try { return storage.getItem(KEY); } catch { return null; }
}

/** True when the notes for `version` have not been seen on this browser yet. */
export function hasUnseenRelease(version, storage = window.localStorage) {
  return lastSeenVersion(storage) !== version;
}

export function markReleaseSeen(version, storage = window.localStorage) {
  try { storage.setItem(KEY, version); } catch { /* it just shows again next time */ }
}
